// src/shared/hooks/usePasswordValidation.ts
import { useState } from "react";

export const usePasswordValidation = (password: string) => {
  const [touched, setTouched] = useState(false);

  const isLengthValid = password.length >= 8 && password.length <= 15;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[^A-Za-z0-9]/.test(password);

  const isValid = isLengthValid && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;

  return {
    touched,
    setTouched,
    validations: {
      isLengthValid,
      hasUpperCase,
      hasLowerCase,
      hasNumber,
      hasSpecialChar,
    },
    isValid,
  };
};
